var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"notfound text-center"},[_c('v-container',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.texts.error404)}}),_c('btn-blue',{attrs:{"to":{name: 'Home'}}},[_vm._v(_vm._s(_vm.buttons.back))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }